import { useEffect, useRef } from "react";

export default function StreakFlame({
  streak = 7,
  size = 120,
  active = false,
  color = [255, 120, 0],
}) {
  const ref = useRef(null);
  const intensityRef = useRef(0);

  useEffect(() => {
    const cv = ref.current;
    const W = size;
    const H = size * 1.25;

    cv.width = W;
    cv.height = H;

    const ctx = cv.getContext("2d");

    const COUNT = Math.round(W * 0.7);

    const pts = Array.from({ length: COUNT }, () => {
      const maxLife = 0.5 + Math.random() * 0.5;
      return {
        x: W * (0.3 + Math.random() * 0.4),
        y: H * (0.85 + Math.random() * 0.1),
        vx: (Math.random() - 0.5) * W * 0.008,
        vy: -(H * (0.005 + Math.random() * 0.012)),
        life: Math.random() * maxLife,
        maxLife,
        r: W * (0.06 + Math.random() * 0.1),
      };
    });

    let raf;

    function draw() {
      ctx.clearRect(0, 0, W, H);

      const target = active ? 1 : 0;
      intensityRef.current += (target - intensityRef.current) * 0.08;
      const intensity = intensityRef.current;

      if (intensity > 0.01) {
        ctx.globalCompositeOperation = "lighter";

        pts.forEach((p) => {
          p.x += p.vx;
          p.y += p.vy * (0.6 + intensity * 0.6);

          p.vy *= 0.995;
          p.vx += (Math.random() - 0.5) * W * 0.003;
          p.vx *= 0.96;

          p.life += 0.018;

          if (p.life >= p.maxLife) {
            Object.assign(p, {
              x: W * (0.3 + Math.random() * 0.4),
              y: H * (0.85 + Math.random() * 0.1),
              vx: (Math.random() - 0.5) * W * 0.008,
              vy: -(H * (0.005 + Math.random() * 0.012)),
              life: 0,
              maxLife: 0.5 + Math.random() * 0.5,
              r: W * (0.06 + Math.random() * 0.1),
            });
          }

          const t = 1 - p.y / (H * 0.9);
          const a = Math.sin((p.life / p.maxLife) * Math.PI) * 0.9 * intensity;

          const [rBase, gBase, bBase] = color;
          const glow = Math.max(0, Math.min(1, t));
          const r = Math.min(255, rBase + glow * 80);
          const g = Math.min(255, gBase + glow * 80);
          const b = Math.min(255, bBase + glow * 80);

          const gr = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * (0.7 + intensity * 0.5));
          gr.addColorStop(0, `rgba(${r},${g},${b},${a})`);
          gr.addColorStop(1, `rgba(${rBase},${gBase},${bBase},0)`);

          ctx.fillStyle = gr;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fill();
        });

        const [rBase, gBase, bBase] = color;
        const core = ctx.createRadialGradient(W * 0.5, H * 0.75, 0, W * 0.5, H * 0.75, W * 0.25);
        core.addColorStop(0, `rgba(${rBase + 100},${gBase + 100},${bBase + 100},${0.4 * intensity})`);
        core.addColorStop(1, `rgba(${rBase},${gBase},${bBase},0)`);
        ctx.fillStyle = core;
        ctx.fillRect(0, 0, W, H);
      }

      ctx.globalCompositeOperation = "source-over";
      const fs = Math.round(W * 0.28);
      ctx.font = `700 ${fs}px Yahfie`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      ctx.strokeStyle = "rgba(100,20,0,0.7)";
      ctx.lineWidth = fs * 0.14;
      ctx.lineJoin = "round";
      ctx.strokeText(streak, W * 0.5, H * 0.72);

      ctx.fillStyle = "#fff";
      ctx.fillText(streak, W * 0.5, H * 0.72);

      raf = requestAnimationFrame(draw);
    }

    draw();

    return () => cancelAnimationFrame(raf);
  }, [streak, size, active, color]);

  return <canvas className="streak-flame" ref={ref} style={{ display: "block" }} />;
}